import React, { useCallback, useState } from 'react';
import { Query } from '../_common';
import SearchBar from '../SearchBar';
import { SearchTypeEnum } from '../../types/SearchTypeEnum';
import { ModalForm, Option } from './interface';
import { GET_ALL_CUSTOMER_PARENTS } from '../../graphql/client/queries';
import {
    GetAllCustomerParents,
    GetAllCustomerParents_getAllCustomerParents as CustomerParent,
} from '../../types/schemaTypes';
import CustomerParentList from './CustomerParentList';
import { Error, Loading } from '../_common';
import AddCustomerParentModal from './AddEditCustomerParentModal/AddEditCustomerParentModal';
import './CustomerParents.scss';
import { useStoreContext } from '../App/StoreProvider';
import { useAuthContext } from '../Auth/AuthProvider';
import { PermissionEnum } from '../../types/PermissionEnum';
import { useQuery, useMutation } from '@apollo/client/react';
import { SAVE_CUSTOMER_PARENT, DELETE_CUSTOMER_PARENT } from '../../graphql/client/mutations';
import { SaveCustomerParent } from '../../types/schemaTypes';
import { Alert } from 'react-bootstrap';


import {  ToastContainer, toast } from 'react-toastify';
import {toastOpt} from '../../utils/helpers/toastHelper'

const toasterOptions = { duration: 2500 };
const Messages = {
    delete: 'CustomerParent deleted successfully',
};
const ErrorMessages = {
    delete: 'Failed to delete CustomerParent',
};

let selectedCustomerParent: CustomerParent | undefined;

const PAGE_SIZE = 50;

const CustomerParents = (): React.ReactElement => {
    const [showAddCustomerParentModal, setShowAddCustomerParentModal] = useState(false);
    const [modalForm, setModalForm] = useState(ModalForm.EMPTY);
    const [isEndOfResults, setIsEndOfResults] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = 'SBS';
    const canEditCustomerParents = useAuthContext().userHasPermission(PermissionEnum.EditCustomerParent);
    const [state] = useStoreContext();
    const {
        customerParentList: { searchPhrase },
    } = state;

    const variables = {
        input: searchPhrase,
    };

    const onCompletedSaveCustomerParent = (data: SaveCustomerParent): void => {
        if (data.saveCustomerParent === null) return;
        const saveCustomerParentErrors = data.saveCustomerParent.errors;
        if (saveCustomerParentErrors && saveCustomerParentErrors.length > 0) {
            setErrorMessage(saveCustomerParentErrors[0] || '');
        } else {
            selectedCustomerParent = undefined;
            setShowAddCustomerParentModal(false);
        }
    };
    const renderToast = (message, type = 'info') => {
        interface ToastProps {
            onClose?: () => void;
        }
        const Comp = (props: ToastProps) => {
            return (
                <Alert variant={type} onClose={props.onClose}>
                    {message}
                </Alert>
            );
        };

        Comp.displayName = 'toast';
        return Comp;
    };
    const onCompleted = action => {
        toast.success(Messages[action],toastOpt);
        //refetch();
    };

    const onActionError = action => {
        toast.error(ErrorMessages[action],toastOpt);
      
        //refetch();
    };
    const [saveCustomerParent] = useMutation<SaveCustomerParent>(SAVE_CUSTOMER_PARENT, {
        onCompleted: onCompletedSaveCustomerParent,
        refetchQueries: () => {
            return [
                {
                    query: GET_ALL_CUSTOMER_PARENTS,
                    variables: { variables },
                },
            ];
        },
    });
    const [deleteCustomerParent] = useMutation(DELETE_CUSTOMER_PARENT, {
        onCompleted: () => onCompleted('delete'),
        onError: () => onActionError('delete'),
        refetchQueries: () => {
            return [
                {
                    query: GET_ALL_CUSTOMER_PARENTS,
                    variables: { variables },
                },
            ];
        },
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onDelete = useCallback(async (record: any) => {
        const variables = { input: { id: record.id } };
        await deleteCustomerParent({ variables });
    }, []);
    const handleOnHide = (): void => {
        selectedCustomerParent = undefined;
        setErrorMessage('');
        setShowAddCustomerParentModal(false);
    };
    const handleOnSave = async (
        id: number,
        customerName: string,
        enabled: boolean,
        extSystemIdentifier: string,
    ): Promise<void> => {
        if (selectedCustomerParent) {
            const selectedCustomerParentMirror = {...selectedCustomerParent}
            selectedCustomerParentMirror.customerName = customerName;
            selectedCustomerParentMirror.enabled = enabled;
            selectedCustomerParentMirror.extSystemIdentifier = extSystemIdentifier;
            selectedCustomerParent ={...selectedCustomerParentMirror}
        }

        const variables = {
            input: {
                id,
                customerName,
                enabled,
                extSystemIdentifier,
            },
        };
        await saveCustomerParent({ variables });
    };
    const { data: customerParentsData } = useQuery<GetAllCustomerParents>(GET_ALL_CUSTOMER_PARENTS);
    const options: Option[] = [];

    if (customerParentsData && customerParentsData.getAllCustomerParents) {
        customerParentsData.getAllCustomerParents.forEach((element: CustomerParent | null) => {
            if (!element || element.id === null) return;
            const id = element.id;
            const displayName = element.customerName ?? '<None>';
            options.push({ id, name: displayName });
        });
    }
    document.title = 'Customer Parents';
    return (
        <Query<GetAllCustomerParents> query={GET_ALL_CUSTOMER_PARENTS} variables={variables}>
            {({
                error,
                data,
                loading,
                refetch,
                fetchMore,
            }): React.ReactElement | null => {

                const offset = data && data.getAllCustomerParents ? data.getAllCustomerParents.length / PAGE_SIZE : 0;

                React.useEffect(()=>{
                    if (
                        offset % 1 !== 0 ||
                        (!isEndOfResults &&
                            data &&
                            data.getAllCustomerParents &&
                            data.getAllCustomerParents.length < PAGE_SIZE)
                    ) {
                        // If offset is not a whole number, the end of the results has been reached. (8/22/19) - BS
                        setIsEndOfResults(true);
                    }
                },[data, data?.getAllCustomerParents?.length]);


                if (loading) {
                    return <Loading />;
                }

                if (error) {
                    return <Error error={error} />;
                }

                const customerParents: CustomerParent[] = [];

                if (data && data.getAllCustomerParents && data.getAllCustomerParents.length !== 0) {
                    data.getAllCustomerParents.forEach((element) => {
                        if (element !== null) customerParents.push(element as CustomerParent);
                    });
                }
                

                return (
                    <div className="CustomerParents-Container">
                        <ToastContainer />
                        <div className="CustomerParents-Top-Container">
                            <div className="CustomerParents-SearchBar">
                                <SearchBar type={SearchTypeEnum.CustomerParent}></SearchBar>
                            </div>
                            <div className="CustomerParents-RightOptions">
                                {canEditCustomerParents && (
                                    <div
                                        className="CustomerParents-Create-New-CustParent Row"
                                        onClick={() => {
                                            setShowAddCustomerParentModal(true);
                                            setModalForm(ModalForm.ADD_CUSTOMER_PARENT);
                                        }}
                                    >
                                        <i className="material-icons CustomerParents-Icon">add_circle</i>
                                        <span className="CustomerParents-Link">Create New Customer Parent</span>
                                    </div>
                                )}
                            </div>
                            <div className="CustomerParents-Errors">{errorMessage}</div>
                        </div>
                        <div className="CustomerParents-Bottom-Container">
                            <div className="CustomerParents-Header-Title">Name</div>
                            <div className="CustomerParents-Header-Title">JDENumber</div>
                            <div className="CustomerParents-Header-Title">Status</div>
                            <div className="CustomerParents-Header-Title">Actions</div>
                        </div>
                        {customerParents.length > 0 && (
                            <CustomerParentList
                                customerParents={customerParents}
                                refetch={refetch}
                                isLoading={loading}
                                canEditCustomerParents={canEditCustomerParents}
                                isEndOfResults={isEndOfResults}
                                onEditClick={CustomerParent => {
                                    setShowAddCustomerParentModal(true);
                                    setModalForm(ModalForm.EDIT_CUSTOMER_PARENT);
                                    selectedCustomerParent = CustomerParent;
                                }}
                                onDelete={onDelete}
                                onLoadMore={() =>
                                    fetchMore({
                                        variables: {
                                            offset,
                                        },
                                        updateQuery: (prev, { fetchMoreResult }) => {
                                            if (
                                                prev &&
                                                fetchMoreResult &&
                                                prev.getAllCustomerParents &&
                                                fetchMoreResult.getAllCustomerParents
                                            ) {
                                                return Object.assign({}, prev, {
                                                    getCustomerParentFiltered: [
                                                        ...prev.getAllCustomerParents,
                                                        ...fetchMoreResult.getAllCustomerParents,
                                                    ],
                                                });
                                            } else {
                                                return prev;
                                            }
                                        },
                                    })
                                }
                            />
                        )}
                        <AddCustomerParentModal
                            show={showAddCustomerParentModal}
                            modalForm={modalForm}
                            options={options}
                            selectedCustomerParent={selectedCustomerParent}
                            onClickHide={handleOnHide}
                            onClickSave={handleOnSave}
                            errorMessage={errorMessage}
                        ></AddCustomerParentModal>
                    </div>
                );
            }}
        </Query>
    );
};

export default CustomerParents;

